import React from "react";

// reactstrap components
import {
  Card,
  CardHeader,
  CardBody,
  CardTitle,
  Table,
  Row,
  Col,
  Button,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Label,
  Input,
  FormGroup,
  Progress,
  InputGroup,
  InputGroupAddon,
  Spinner,
} from "reactstrap";

import axios from "axios";
import { useState, useEffect } from "react";
import { PERANGKAT_DAERAH, API_TIMEOUT } from "utils";
import { toProperCase } from "utils/func";
import FIREBASE from "../config/FIREBASE";
import swal from "sweetalert";

import { useHistory } from "react-router-dom";

import { API_MAI_FALI } from "utils";
import { logoutUser } from "../actions/AuthAction";

function UsersSioEsa(props) {
  const [tabelPerangkatDaerah, setTabelPerangkatDaerah] = useState([]);
  const [modalOpen, setModalOpen] = useState(false);
  const [modalOpen2, setModalOpen2] = useState(false);
  const [dokumen, setDokumen] = useState("");

  const [status, setStatus] = useState("");
  const [username, setUsername] = useState("");
  const [nama, setNama] = useState("");

  const [url, setUrl] = useState("");
  const [uid, setUid] = useState("");
  const [cari, setCari] = useState(false);
  const [gambar, setGambar] = useState("");
  const [tambah, setTambah] = useState(true);
  const [searchItem, setSearchItem] = useState("");
  const [id_unit, setId_unit] = useState("");
  const [listPd, setListPd] = useState([]);

  const [currentUser, setCurrentUser] = useState("");
  const [accessToken, setAccessToken] = useState("");

  const [listDinas, setListDinas] = useState([]);
  const [listUsers, setListUsers] = useState([]);

  const [profil, setProfil] = useState(null);

  const [userIdToDelete, setUserIdToDelete] = useState(null);

  const history = useHistory();

  const onChangeDok = (e) => {
    setDokumen(e.target.files[0]);
  };

  useEffect(() => {
    const user = localStorage.getItem("user");
    if (user) {
      setCurrentUser(user);
      ambilUsers();
      ambilPerangkatDaerah();
    } else {
      logoutUser(props.history);
    }
  }, [props.history]);

  const handleSimpan = () => {
    if (!nama || !username || !status || !id_unit) {
      swal("Gagal", "Data yang anda masukan harus lengkap", "error");
      return;
    }
    simpanAdmin();
  };

  const simpanAdmin = async () => {
    const formData = new FormData();
    formData.append("nama", nama);
    formData.append("idDinas", id_unit);
    formData.append("uidRSS", uid);
    formData.append("status", status);
    formData.append("email", username);
    if (profil) {
      formData.append("profil", gambar);
    }

    try {
      const response = await axios.post(`${API_MAI_FALI}users`, formData, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      });
      if (response.status === 201) {
        swal("Success", "User berhasil ditambahkan", "success");
        ambilUsers();
        onCloseModal();
      } else {
        swal(
          "Failed",
          response.data.message || "Ada kesalahan pada server",
          "error"
        );
      }
    } catch (error) {
      swal(
        "Failed",
        error.response?.data?.message || "Ada kesalahan pada server",
        "error"
      );
    }
  };

  const convertGambar = (avatar) => {
    // Data gambar dalam format data URI
    if (avatar) {
      const imageDataURI = avatar; // Sisipkan data gambar lengkap di sini

      // Memisahkan data URI menjadi tipe dan base64 encoded data
      const [dataType, base64Data] = imageDataURI.split(",");

      // Mengubah base64 encoded data menjadi bentuk binary
      const binaryData = atob(base64Data);

      // Mendapatkan panjang data binary
      const len = binaryData.length;

      // Membuat array untuk menyimpan data binary dalam bentuk Uint8Array
      const uint8Array = new Uint8Array(len);

      // Mengisi array dengan data binary
      for (let i = 0; i < len; i++) {
        uint8Array[i] = binaryData.charCodeAt(i);
      }

      // Membuat file baru dari Uint8Array dan menambahkan tipe datanya
      const file = new File([uint8Array], "gambar.jpg", { type: dataType });

      setGambar(file);
    } else {
      setGambar("");
    }
  };

  const ambilPerangkatDaerah = (id) => {
    axios({
      method: "get",
      url: PERANGKAT_DAERAH,
      timeout: API_TIMEOUT,
      credentials: "include",
      headers: {
        Authorization: `Bearer ${accessToken}`,
      },
    })
      .then((response) => {
        if (response.status !== 200) {
          // ERROR
          return "error";
        } else {
          //BERHASIL

          const data = response.data.data;

          setListPd(data);
        }
      })
      .catch((error) => {
        // ERROR

        alert(error);
      });
  };

  const ambilUsers = (id) => {
    axios({
      method: "get",
      url: API_MAI_FALI + "users",
    })
      .then((response) => {
        if (response.status !== 200) {
          // ERROR
          return "error";
        } else {
          //BERHASIL

          const data = response.data.data;
          setListUsers(data);
        }
      })
      .catch((error) => {
        // ERROR

        alert(error);
      });
  };

  const getUserEmail = (email) => {
    FIREBASE.database()
      .ref("users")
      .orderByChild("email")
      .equalTo(email)
      .once("value", (querySnapshot) => {
        //hasil disini

        let data = querySnapshot.val() ? querySnapshot.val() : [];
        let arrayOfNames = [];
        for (const key in data) {
          if (data.hasOwnProperty(key)) {
            const nama = data[key];
            arrayOfNames.push(nama);
          }
        }

        if (data) {
          setCari(false);
          setNama(arrayOfNames[0].nama);
          setUsername(arrayOfNames[0].email);

          //  setDinas(arrayOfNames[0].unitKerja);
          setUrl(arrayOfNames[0].avatar);
          setUid(arrayOfNames[0].uid);
          convertGambar(arrayOfNames[0].avatar);
        } else {
          setCari(false);
          swal("Gagal", "Username tidak ditemukan", "failed");
        }
      })
      .catch((error) => {
        setCari(false);
        swal("Gagal", "Username tidak ditemukan", "failed");
      });
  };

  const cariUser = (email) => {
    setCari(true);
    getUserEmail(email);
  };

  const onCloseModal = () => {
    setNama("");
    setUsername("");
    setUid("");
    setUrl("");
    setGambar("");
    setSearchItem("");
    setId_unit("");
    setModalOpen(false);
  };

  const onModalClose2 = () => {
    setNama("");
    setUserIdToDelete(null);
    setModalOpen2(false);
  };

  const handleDelete = async () => {
    if (!userIdToDelete) return;
    try {
      const response = await axios.delete(
        `${API_MAI_FALI}users/${userIdToDelete}`
      );
      if (response.status === 200) {
        swal("Sukses", "Data user " + nama + " berhasil dihapus", "success");
        ambilUsers();
        onModalClose2();
      } else {
        swal("Gagal", response.data.message || "Gagal menghapus user", "error");
      }
    } catch (error) {
      swal(
        "Gagal",
        error.response?.data?.message || "Gagal menghapus user",
        "error"
      );
    }
  };

  return (
    <>
      <div className="content">
        <Row>
          <Col md="12">
            <Card>
              <CardHeader
                style={{
                  display: "flex",
                  flexDirection: "row",
                  justifyContent: "space-between",
                }}
              >
                <CardTitle tag="h4">Pengguna Sio Esa</CardTitle>
                <Button color="danger" onClick={() => setModalOpen(true)}>
                  Tambah User
                </Button>
              </CardHeader>

              <CardBody>
                <Table className="tablesorter" responsive>
                  <thead className="text-primary">
                    <tr>
                      <th>No</th>
                      <th>Nama</th>
                      <th>Institusi</th>
                      <th>Email</th>
                      <th className="text-center">Status</th>
                      <th>Action</th>
                    </tr>
                  </thead>
                  <tbody>
                    {listUsers &&
                      listUsers.map((item, index) => (
                        <tr>
                          <td>{index + 1}</td>
                          <td>{item.nama}</td>
                          <td>{toProperCase(item.idDinas)}</td>
                          <td style={{ cursor: "pointer" }}>{item.email}</td>
                          <td className="text-center" style={{ width: 100 }}>
                            {item.status == 1 ? "admin" : "user"}
                          </td>
                          <td>
                            <div
                              style={{ display: "flex", flexDirection: "row" }}
                            >
                              <Button
                                size="sm"
                                color="primary"
                                style={{ marginRight: 5 }}
                              >
                                Edit
                              </Button>
                              <Button
                                size="sm"
                                color="danger"
                                onClick={() => {
                                  setNama(item.nama);
                                  setUserIdToDelete(item.id);
                                  setModalOpen2(true);
                                }}
                              >
                                delete
                              </Button>
                            </div>
                          </td>
                        </tr>
                      ))}
                  </tbody>
                </Table>
              </CardBody>
            </Card>
          </Col>
        </Row>
        <Modal
          size="md"
          isOpen={modalOpen}
          toggle={() => setModalOpen(false)}
          contentClassName="p-0"
          modalClassName="modal-slide-in event-sidebar"
        >
          <ModalHeader toggle={() => setModalOpen(false)}>
            <div>
              <div className="headline-2">{"Tambah User"}</div>
            </div>
          </ModalHeader>
          <ModalBody>
            {tambah && (
              <FormGroup>
                <InputGroup>
                  <Input
                    type="text"
                    id="search-input1"
                    value={searchItem}
                    style={{ color: "black" }}
                    onChange={(e) => setSearchItem(e.target.value)}
                  />
                  <InputGroupAddon addonType="append">
                    {cari ? (
                      <Button color="default" disabled>
                        <Spinner size="sm" color="white" /> Loading
                      </Button>
                    ) : (
                      <Button
                        color="default"
                        onClick={() => cariUser(searchItem)}
                      >
                        Search
                      </Button>
                    )}
                  </InputGroupAddon>
                </InputGroup>
              </FormGroup>
            )}
            {url && (
              <Row style={{ display: "flex", justifyContent: "center" }}>
                <img
                  src={url ? url : ""}
                  style={{
                    width: 100,
                    height: 100,
                    borderRadius: 50,

                    marginBottom: 10,
                    border: "2px solid blue",
                  }}
                />
              </Row>
            )}

            {nama && (
              <div>
                <FormGroup row>
                  <Label md={3} for="normal-field" className="text-md-right">
                    Nama
                  </Label>
                  <Col md={9}>
                    <Input
                      type="text"
                      id="default-textarea"
                      placeholder="nama"
                      value={nama}
                      style={{ color: "black" }}
                      onChange={(e) => setNama(e.target.value)}
                      required
                    />
                  </Col>
                </FormGroup>
                <FormGroup row>
                  <Label md={3} for="normal-field" className="text-md-right">
                    Username
                  </Label>
                  <Col md={9}>
                    <Input
                      type="text"
                      id="default-textarea"
                      placeholder="username"
                      style={{ color: "black" }}
                      value={username}
                      onChange={(e) => setUsername(e.target.value)}
                      required
                    />
                  </Col>
                </FormGroup>
                <FormGroup row>
                  <Label md={3} for="normal-field" className="text-md-right">
                    Peran
                  </Label>
                  <Col md={9}>
                    <Input
                      type="select"
                      id="normal-field"
                      style={{ color: "black" }}
                      value={status}
                      onChange={(e) => setStatus(e.target.value)}
                    >
                      <option value={""}>- pilih - </option>
                      <option value={1}>admin</option>
                      <option value={2}>user </option>
                    </Input>
                  </Col>
                </FormGroup>
                <FormGroup row>
                  <Label md={3} for="normal-field" className="text-md-right">
                    Perangkat Daerah/Ormas
                  </Label>
                  <Col md={9}>
                    <Input
                      type="text"
                      id="normal-field"
                      placeholder="Institusi"
                      value={id_unit}
                      style={{ color: "black" }}
                      onChange={(e) => setId_unit(e.target.value)}
                    />
                  </Col>
                </FormGroup>
                <FormGroup row>
                  <Label md={3} for="profil" className="text-md-right">
                    Foto Profil
                  </Label>
                  <Col md={9}>
                    <Input
                      type="file"
                      id="profil"
                      accept="image/*"
                      onChange={(e) => setProfil(e.target.files[0])}
                    />
                  </Col>
                </FormGroup>
              </div>
            )}
          </ModalBody>
          <ModalFooter style={{ justifyContent: "center", paddingBottom: 10 }}>
            <div
              style={{
                display: "flex",
                flexDirection: "row",
                justifyContent: "flex-end",
                alignItems: "flex-end",
              }}
            >
              <Button
                className="btn-rounded"
                size="sm"
                color="secondary-red"
                onClick={onCloseModal}
              >
                Cancel
              </Button>
              <div style={{ marginLeft: 5 }}></div>
              <Button
                className="btn-rounded"
                color="primary"
                size="sm"
                onClick={() => handleSimpan()}
              >
                {" "}
                {"Simpan"}
              </Button>
            </div>
          </ModalFooter>
        </Modal>
        <Modal
          size="md"
          isOpen={modalOpen2}
          toggle={() => onModalClose2()}
          contentClassName="p-0"
          modalClassName="modal-slide-in event-sidebar"
        >
          <ModalHeader toggle={() => onModalClose2()}>
            <div>
              <div className="headline-2">Konfirmasi hapus akun</div>
            </div>
          </ModalHeader>
          <ModalBody>
            Apakah anda ingin menghapus akun atas nama {nama} ?
          </ModalBody>
          <ModalFooter style={{ justifyContent: "center", paddingBottom: 10 }}>
            <div
              style={{
                display: "flex",
                flexDirection: "row",
                justifyContent: "flex-end",
                alignItems: "flex-end",
              }}
            >
              <Button
                className="btn-rounded"
                size="sm"
                color="secondary-red"
                onClick={() => onModalClose2()}
              >
                Cancel
              </Button>
              <div style={{ marginLeft: 5 }}></div>
              <Button
                className="btn-rounded"
                color="primary"
                size="sm"
                onClick={handleDelete}
              >
                Hapus
              </Button>
            </div>
          </ModalFooter>
        </Modal>
      </div>
    </>
  );
}

export default UsersSioEsa;
